module.exports = new __parcel__URL__("john-wick.dd61aa3a.jpg").toString();